<i18n>
{
  "fr": {
  },
  "en": {}
}
</i18n>

<template>
  <div>
    <div class="modal-card" style="width: 900px; height: auto">
      <section class="modal-card-body">
        <b-icon icon="flask" size="is-large"></b-icon>
        {{ entity.name }}
      </section>
      <entity-map :entity="entity" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EntityView',
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  components: {
    'entity-map': () => import('@/components/transition/AbstractEntityMap.vue')
  }
}
</script>

<style></style>
